import { useEffect, useState } from "react";

const MenuComponent = () => {
  const [activeMenuCategory, setActiveMenuCategory] = useState("body");

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace("#menu-", "");
      if (["body", "foot", "set"].includes(hash)) {
        setActiveMenuCategory(hash);
      }
    };

    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  // メニューデータ：手もみ王（Temomio）のWebサイト情報を反映
  // ※価格は調査時点の税込標準価格（10%）に基づきます
  const menuData = {
    body: [
      {
        name: "もみほぐしコース 30分",
        price: "2,200円",
        desc: "時間がない時でもサクッと疲れをケアしたい方に。",
      },
      {
        name: "もみほぐしコース 45分",
        price: "2,970円",
        desc: "部分的な疲れや、少し時間が空いた時のリフレッシュに。",
      },
      {
        name: "もみほぐしコース 60分",
        price: "3,740円",
        desc: "【人気No.1】うつ伏せと仰向けの全身施術。ストレッチを取り入れ血行を促進します。",
      },
      {
        name: "もみほぐしコース 90分",
        price: "5,390円",
        desc: "全身＋お疲れの箇所をじっくり。リピーター様に人気のロングコース。",
      },
      {
        name: "もみほぐしコース 120分",
        price: "7,260円",
        desc: "溜まった疲れを時間をかけて徹底的に解消したい方に。",
      },
    ],
    foot: [
      {
        name: "足つぼコース 30分",
        price: "2,750円",
        desc: "オイル・クリームを使い、足裏の反射区を刺激して血行を良くします。",
      },
      {
        name: "足つぼコース 45分",
        price: "3,520円",
        desc: "足裏に加え、ふくらはぎまでしっかり流してむくみを解消。",
      },
      {
        name: "足つぼコース 60分",
        price: "4,290円",
        desc: "【当店オススメ】立ち仕事などで足の疲れがピークの方にじっくりケア。",
      },
      {
        name: "足つぼコース 90分",
        price: "6,270円",
        desc: "足元から全身の疲れをリフレッシュ。深いリラクゼーション効果も期待できます。",
      },
    ],
    set: [
      {
        name: "もみほぐし＆足つぼ半々 60分",
        price: "4,070円",
        desc: "【当店オススメ】足つぼ30分＋もみほぐし30分のセット。足元から血流を良くし全身をほぐします。",
      },
      {
        name: "もみほぐし＆足つぼ半々 90分",
        price: "5,720円",
        desc: "足つぼでリラックスした状態で、全身をじっくりほぐせる贅沢コース。",
      },
      {
        name: "もみほぐし＆足つぼ半々 120分",
        price: "7,700円",
        desc: "全身くまなく徹底ケア。自分へのご褒美に最適なスペシャルコース。",
      },
    ],
  };

  return (
    <section
      id="menu"
      className="pt-12 pb-16 md:pt-20 md:pb-24 relative bg-[#fffcf5] border-t border-orange-50"
    >
      {/* アンカーリンク用ターゲット */}
      <div id="menu-body" className="absolute -top-24 left-0 w-full h-0" />
      <div id="menu-foot" className="absolute -top-24 left-0 w-full h-0" />
      <div id="menu-set" className="absolute -top-24 left-0 w-full h-0" />

      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-10">
          <h3 className="text-2xl md:text-4xl font-black text-gray-900 tracking-tight">
            メニュー・料金
          </h3>
        </div>

        {/* Tabs */}
        <div className="flex justify-center gap-2 md:gap-4 mb-8">
          {[
            {
              id: "body",
              label: "もみほぐし",
              sub: "Body Care",
              color: "from-orange-400 to-red-500",
            },
            {
              id: "foot",
              label: "足つぼ",
              sub: "Foot Care",
              color: "from-yellow-400 to-orange-500",
            },
            {
              id: "set",
              label: "半々セット",
              sub: "Set Course",
              color: "from-pink-400 to-rose-500",
            },
          ].map((tab) => (
            <button
              type="button"
              key={tab.id}
              onClick={() => setActiveMenuCategory(tab.id)}
              className={`relative px-4 md:px-8 py-3 rounded-xl transition-all duration-300 transform ${
                activeMenuCategory === tab.id
                  ? `bg-gradient-to-br ${tab.color} text-white shadow-lg z-10`
                  : "bg-white border-2 border-gray-100 text-gray-500 hover:border-orange-200 hover:text-orange-400 hover:-translate-y-1"
              }`}
            >
              <span className="block text-sm md:text-base font-black tracking-wide">
                {tab.label}
              </span>
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-[var(--temomi-shadow-md)] border border-gray-100 overflow-hidden animate-fade-in min-h-[300px]">
          <div className="divide-y divide-gray-50">
            {menuData[activeMenuCategory as keyof typeof menuData].map(
              (item) => (
                <div
                  key={item.name}
                  className="p-4 md:p-6 hover:bg-[var(--temomi-soft)] transition-colors duration-300 flex flex-col md:flex-row md:items-center justify-between gap-2 group"
                >
                  <div className="flex-1">
                    <div className="flex justify-between items-baseline mb-1">
                      <h4 className="text-base md:text-lg font-bold text-gray-800 flex items-center gap-2 group-hover:text-[var(--temomi-red)] transition-colors">
                        {item.name}
                      </h4>
                      <span className="text-lg font-bold text-[var(--temomi-red)] md:hidden">
                        {item.price}
                      </span>
                    </div>
                    <p className="text-xs md:text-sm text-gray-500 leading-relaxed font-medium">
                      {item.desc}
                    </p>
                  </div>
                  <div className="hidden md:flex flex-col items-end min-w-[120px] pl-4 border-l border-gray-100">
                    <span className="text-[10px] text-gray-400 mb-0.5 tracking-wider">
                      税込
                    </span>
                    <span className="text-xl font-bold text-[var(--temomi-red)] tracking-tight font-feature-settings-tnum">
                      {item.price}
                    </span>
                  </div>
                </div>
              ),
            )}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fade-in 0.4s ease-out forwards;
        }
      `}</style>
    </section>
  );
};

export default MenuComponent;
